export const type = {
  bodySmall: "1.6rem",
  body: "2rem",
  cardHeader: "2.4rem",
  sectionHeader: "4.2rem",
  hero: "5rem"
};

export const typeMobile = {
  bodySmall: "1.2rem",
  body: "1.4rem",
  cardHeader: "1.8rem",
  sectionHeader: "2rem",
  hero: "2.8rem",
  heroLineHeight: "3.2rem"
};

export const sectionSpace = {
  desktop: "5rem 0",
  mobile: "2.5rem 0"
};
